import React from 'react';
import Big from 'big.js';
import CircleChart from '@appComponents/CircleChart/CircleChart';
import IFundsChart, { TFundsChart } from './IFundsChart';
import { IWalletDetails } from '@market/interfaces/IWallet';
import { Link } from 'react-router-dom';
import * as style from './FundsChartStyle.module.scss'

const big = Big();

export default class FundsChart extends React.Component<IFundsChart, TFundsChart> {
  constructor(props: IFundsChart) {
    super(props);
    const chartData = this.getPieData(this.props.data);

    this.state = {
      series: chartData.data,
      labels: chartData.labels.map(label => label || ''),
      colors: ['#d027ff', '#37A1FF', '#F7B501', '#48AA43', '#FA6400'],
    };
  }


  getPieData = (data: Pick<IWalletDetails, 'total_usd' | 'currency_name'>[]) => {
    const bestCurrencies:[number, string][] = data.slice(0, 4).map(el => [Number(el.total_usd), el.currency_name]);

    const rest = data.slice(4)
      .map(el => el.total_usd || 0).reduce((prev, curr) => Number(big(prev).add(curr)), 0);

    return {
      data: rest ? [...bestCurrencies.map(el => el[0]), rest] : bestCurrencies.map(el => el[0]),
      labels: rest ? [...bestCurrencies.map(el => el[1]), 'Other'] : bestCurrencies.map(el => el[1]),
    };
  }

  render() {
    return (
      <>
        {this.props.manageAccountLink && <Link to={'funds/accounts'} className={style.link}>Go To Manage Accounts</Link>}
        <CircleChart {...this.state} sum={this.props.sum} headline={this.props.headline || "Estimated total funds"} />
      </>
    );
  }
}
